import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '@/views/Login.vue';
import Logout from '@/views/Logout.vue';
import AppFast from '@/views/AppFast.vue';

import DeliveryIndex from '@/views/Delivery/Index.vue';
import DeliveryList from '@/views/Delivery/DeliveryList.vue';
import DeliveryCreate from '@/views/Delivery/CreateOrder.vue';
import DeliveryEdit from '@/views/Delivery/EditOrder.vue';
import DeliveryInformation from '@/views/Delivery/Information.vue';
import DeliveryImport from '@/views/Delivery/ImportCSV.vue';
import WaitingDeliveryList from '@/views/Delivery/WaitingOrder.vue';
import ReceivableList from '@/views/Delivery/ReceivableList.vue';
import CancelDeliveryList from '@/views/Delivery/CancelOrder.vue';

import OverallIndex from '@/views/Overall/Index.vue';
import OverallDashboard from '@/views/Overall/Dashboard.vue';
import OverallDeliveryNoteHistory from '@/views/Overall/DeliveryNoteHistory.vue';
import OverallTotal from '@/views/Overall/Total.vue';
import OverallHubTotal from '@/views/Overall/HubTotal.vue';

import DeliveryNoteIndex from '@/views/DeliveryNote/Index.vue';
import DeliveryNoteCreate from '@/views/DeliveryNote/CreateDeliveryNote.vue';
import DeliveryNoteCreateSingle from '@/views/DeliveryNote/CreateSingleDeliveryNote.vue';
import DeliveryNoteList from '@/views/DeliveryNote/DeliveryNoteList.vue';
import DeliveryNoteInformation from '@/views/DeliveryNote/DeliveryNoteInformation.vue';

import ProductIndex from '@/views/Product/Index.vue';
import ProductList from '@/views/Product/ProductList.vue';
import CreateProduct from '@/views/Product/CreateProduct.vue';
import CreateProductType from '@/views/Product/CreateProductType.vue';
import UpdateProduct from '@/views/Product/UpdateProduct.vue';

import RecordsIndex from '@/views/Records/Index.vue';

import DriverList from '@/views/Records/DriverList.vue';
import DriverInformation from '@/views/Records/DriverInformation.vue';

import VehicleList from '@/views/Records/VehicleList.vue';
import VehicleInformation from '@/views/Records/VehicleInformation.vue';
import CreateVehicleCashflow from '@/views/Records/CreateVehicleCashflow.vue';
import CreateDriverCashflow from '@/views/Records/CreateDriverCashflow.vue';
import CreateDriverExpense from '@/views/Records/CreateDriverExpense.vue';

import InvoiceIndex from '@/views/Invoice/Index.vue';
import InvoiceOverall from '@/views/Invoice/Overall.vue';
import InvoiceList from '@/views/Invoice/InvoiceList.vue';

import CashFlowIndex from '@/views/CashFlow/Index.vue';
import CashFlowOverall from '@/views/CashFlow/Overall.vue';
import CashFlowList from '@/views/CashFlow/CashFlowList.vue';
import CashFlowCreate from '@/views/CashFlow/CreateCashFlow.vue';

import ReportIndex from '@/views/Report/Index.vue';
import ReportList from '@/views/Report/List.vue';
import ReportCSVRouter from '@/views/Report/CSV/csv-report-router';

import AnalyticsIndex from '@/views/Report/Analytic/Index.vue';
import AnalyticsRouter from '@/views/Report/Analytic/analytic-router';

import SettingIndex from '@/views/Setting/Index.vue';
import SettingCompany from '@/views/Setting/Company.vue';

import SettingDriver from '@/views/Setting/Driver/Driver.vue';
import SettingEditDriver from '@/views/Setting/Driver/EditDriver.vue';
import SettingCreateDriver from '@/views/Setting/Driver/CreateDriver.vue';

import SettingVehicle from '@/views/Setting/Vehicle/Vehicle.vue';
import SettingEditVehicle from '@/views/Setting/Vehicle/EditVehicle.vue';
import SettingCreateVehicle from '@/views/Setting/Vehicle/CreateVehicle.vue';

import SettingArea from '@/views/Setting/AreaCode.vue';
import SettingDebtor from '@/views/Setting/Debtor.vue';
import SettingDriverPayout from '@/views/Setting/DriverPayout.vue';
import SettingCashflowCategories from '@/views/Setting/CashflowCategories.vue';
import SettingPaymentAccount from '@/views/Setting/PaymentAccount.vue';

import SettingUser from '@/views/Setting/User/Index.vue';
import SettingUserList from '@/views/Setting/User/List.vue';
import SettingUserNew from '@/views/Setting/User/New.vue';
import SettingUserEdit from '@/views/Setting/User/Edit.vue';

import SettingUsage from '@/views/Setting/Usage.vue';

import SettingSystemCalendarIndex from '@/views/Setting/SystemCalendar/Index.vue';

import Profile from '@/views/Profile/Index.vue';
import ProfileSetting from '@/views/Profile/Profile.vue';
import ProfileSystemDisplay from '@/views/Profile/SystemDisplay.vue';
import ProfileCompanyStatistic from '@/views/Profile/Statistics.vue';

import Tracking from '@/views/Tracking/Tracking.vue';
import AppUpdateTrackingStatus from '@/views/Tracking/UpdateTracking.vue';

import Error from '../views/Error.vue';

Vue.use(VueRouter);

// const guardAuth = async (to: Route, from: Route, next: (route?: any) => void) => {
//   next();
// };

const routes = [
  { // when from: login single field, provide company logo unless main domain
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
  {
    path: '/tracking',
    name: 'Tracking',
    component: Tracking,
  },
  {
    path: '/android-preview/:id',
    name: 'AppUpdateTrackingStatus',
    component: AppUpdateTrackingStatus,
  },
  {
    path: '/app',
    // beforeEnter: guardAuth, // Check only root, no need to check children
    component: AppFast,
    children: [
      {
        path: 'dashboard',
        component: OverallDashboard,
        name: 'Dashboard',
      },
      {
        path: 'delivery-notes-history',
        component: OverallDeliveryNoteHistory,
        name: 'OverallDeliveryNotesHistory',
      },
      {
        path: 'overall',
        component: OverallIndex,
        children: [
          {
            path: 'shipping',
            name: 'OverallDashboard',
            component: OverallDashboard,
          },
          {
            path: 'total',
            name: 'OverallTotal',
            component: OverallTotal,
          },
          {
            path: 'hub-total',
            name: 'OverallHubTotal',
            component: OverallHubTotal,
          },
        ],
      },
      {
        path: 'delivery',
        component: DeliveryIndex,
        children: [
          {
            path: 'cancel',
            name: 'CancelDeliveryList',
            component: CancelDeliveryList,
          },
          {
            path: 'waiting',
            name: 'WaitingDeliveryList',
            component: WaitingDeliveryList,
          },
          {
            path: 'create',
            name: 'DeliveryCreate',
            component: DeliveryCreate,
          },
          {
            path: 'edit/:id',
            name: 'DeliveryEdit',
            component: DeliveryEdit,
          },
          {
            path: 'import',
            name: 'DeliveryImport',
            component: DeliveryImport,
          },
          {
            path: 'list',
            name: 'DeliveryList',
            component: DeliveryList,
          },
          {
            path: 'receivable',
            name: 'ReceivableList',
            component: ReceivableList,
          },
          {
            path: ':id',
            name: 'DeliveryInformation',
            component: DeliveryInformation,
          },
        ],
      },
      {
        path: 'delivery-note',
        component: DeliveryNoteIndex,
        children: [
          {
            path: 'create',
            name: 'DeliveryNoteCreate',
            component: DeliveryNoteCreate,
          },
          {
            path: 'create-single',
            name: 'DeliveryNoteCreateSingle',
            component: DeliveryNoteCreateSingle,
          },
          {
            path: 'edit/:id',
            name: 'DeliveryNoteEdit',
            component: DeliveryNoteCreateSingle,
          },
          {
            path: 'list',
            name: 'DeliveryNoteList',
            component: DeliveryNoteList,
          },
          {
            path: ':id',
            name: 'DeliveryNoteInformation',
            component: DeliveryNoteInformation,
          },
        ],
      },
      {
        path: 'product',
        component: ProductIndex,
        children: [
          {
            path: 'product-list',
            name: 'ProductList',
            component: ProductList,
          },
          {
            path: 'create-product',
            name: 'CreateProduct',
            component: CreateProduct,
          },
          {
            path: 'create-product-type',
            name: 'CreateProductType',
            component: CreateProductType,
          },
          {
            path: 'update-product',
            name: 'UpdateProduct',
            component: UpdateProduct,
          },
        ],
      },
      {
        path: 'driver',
        component: RecordsIndex,
        redirect: { name: 'DriverList' },
        children: [
          {
            path: '',
            name: 'DriverList',
            component: DriverList,
            children: [
              {
                path: ':id',
                name: 'DriverInformation',
                component: DriverInformation,
              },
              {
                path: ':id/new-expense',
                name: 'CreateDriverExpense',
                component: CreateDriverExpense,
              },
              {
                path: ':id/new-cashflow',
                name: 'CreateDriverCashflow',
                component: CreateDriverCashflow,
              },
            ],
          },
        ],
      },
      {
        path: 'vehicle',
        component: RecordsIndex,
        redirect: { name: 'VehicleList' },
        children: [
          {
            path: '',
            name: 'VehicleList',
            component: VehicleList,
            children: [
              {
                path: ':id',
                name: 'VehicleInformation',
                component: VehicleInformation,
              },
              {
                path: ':id/new-cashflow',
                name: 'CreateVehicleCashflow',
                component: CreateVehicleCashflow,
              },
              {
                path: ':id/edit-cashflow/cashflowId',
                name: 'EditVehicleCashflow',
                component: CreateVehicleCashflow,
              },
            ],
          },
        ],
      },
      {
        path: 'invoice',
        component: InvoiceIndex,
        children: [
          {
            path: 'list',
            name: 'InvoiceList',
            component: InvoiceList,
          },
          {
            path: 'overall',
            name: 'InvoiceOverall',
            component: InvoiceOverall,
          },
        ],
      },
      {
        path: 'cashflow',
        component: CashFlowIndex,
        children: [
          {
            path: 'list',
            name: 'CashFlowList',
            component: CashFlowList,
          },
          {
            path: 'overall',
            name: 'CashFlowOverall',
            component: CashFlowOverall,
          },
          {
            path: 'create',
            name: 'CashFlowCreate',
            component: CashFlowCreate,
          },
        ],
      },
      {
        path: 'report',
        component: ReportIndex,
        children: [
          {
            path: 'report/analytics',
            component: AnalyticsIndex,
            name: 'AnalyticsIndex',
            children: AnalyticsRouter,
          },
          {
            path: 'report-list',
            name: 'ReportList',
            component: ReportList,
            children: [
              ...ReportCSVRouter,
            ],
          },
        ],
      },
      {
        path: 'setting',
        component: SettingIndex,
        children: [
          {
            // ตั้งค่าบริษัท
            path: 'componay',
            name: 'SettingCompany',
            component: SettingCompany,
          },
          {
            // ตั้งค่าคนขับรถ
            path: 'driver',
            name: 'SettingDriver',
            component: SettingDriver,
            children: [
              {
                path: 'new',
                name: 'SettingCreateDriver',
                component: SettingCreateDriver,
              },
              {
                path: 'edit/:id',
                name: 'SettingEditDriver',
                component: SettingEditDriver,
              },
            ],
          },
          {
            // ตั้งค่ารถขนส่ง
            path: 'vehicle',
            name: 'SettingVehicle',
            component: SettingVehicle,
            children: [
              {
                path: 'new',
                name: 'SettingCreateVehicle',
                component: SettingCreateVehicle,
              },
              {
                path: 'edit/:id',
                name: 'SettingEditVehicle',
                component: SettingEditVehicle,
              },
            ],
          },
          {
            // ตั้งค่า Area code
            path: 'area',
            name: 'SettingArea',
            component: SettingArea,
          },
          {
            // ตั้งค่าผลตอบแทน
            path: 'payment',
            name: 'SettingDriverPayout',
            component: SettingDriverPayout,
          },
          {
            // ตั้งค่าบัญชีค่าใช้จ่าย
            path: 'account',
            name: 'SettingPaymentAccountIndex',
            component: SettingCashflowCategories,
            children: [
              {
                path: ':id',
                name: 'SettingPaymentAccount',
                component: SettingPaymentAccount,
              },
            ],
          },
          {
            // ตั้งค่าบัญชีลูกหนี้
            path: 'debtor',
            name: 'SettingDebtor',
            component: SettingDebtor,
          },
          {
            // ดูประวัติการใช้งาน
            path: 'usage',
            name: 'SettingUsage',
            component: SettingUsage,
          },
          {
            // ตั้งค่าข้อมูลผู้ใช้
            path: 'user',
            name: 'UserIndex',
            component: SettingUser,
            redirect: { name: 'User' },
            children: [
              {
                path: '',
                name: 'User',
                component: SettingUserList,
              },
              {
                path: ':roleId',
                name: 'UserList',
                component: SettingUserList,
              },
              {
                path: ':initRole/new',
                name: 'UserNew',
                component: SettingUserNew,
              },
              {
                path: 'edit/:id',
                name: 'UserEdit',
                component: SettingUserEdit,
              },
            ],
          },
          {
            // ตั้งค่าปฏิทินระบบ
            path: 'system-calendar',
            name: 'SettingSystemCalendarIndex',
            component: SettingSystemCalendarIndex,
          },
        ],
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
        children: [
          {
            path: 'setting',
            name: 'ProfileSetting',
            component: ProfileSetting,
          },
          {
            path: 'system',
            name: 'SystemDisplay',
            component: ProfileSystemDisplay,
          },
          {
            path: 'static',
            name: 'CompanyStatistic',
            component: ProfileCompanyStatistic,
          },
        ],
      },
    ],
  },
  { path: '*', component: Error },
];

const router = new VueRouter({
  routes,
});

export default router;
